export const CONSENT_OPTIONS = [
  { label: "Unknown", value: null },
  { label: "Consent", value: true },
  { label: "No Consent", value: false },
];

export const CONSENT_FIELDS = [
  { name: "isConsentForEmail", label: "Consent for Email", tagLabel: "Email" },
  { name: "isConsentForText", label: "Consent for Text", tagLabel: "Text" },
  { name: "isConsentForAiCalls", label: "Consent for AI Calls", tagLabel: "AI Calls" },
];

export const formatConsent = (value) => {
  if (value === true) return "Consent";
  if (value === false) return "No Consent";
  return "Unknown";
};
